var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container-center scoped-new-emailTemplatesEditor" },
    [
      _c("x-test", { attrs: { id: "action::surveyEmailTemplates" } }),
      [
        _vm.languageChangerEnabled
          ? _c(
              "div",
              { staticClass: "row" },
              [
                _c("language-selector", {
                  attrs: {
                    elId: "emailTemplatesEditor",
                    aLanguages: _vm.$store.state.languages,
                    parentCurrentLanguage: _vm.$store.state.activeLanguage
                  },
                  on: { change: _vm.selectLanguage }
                })
              ],
              1
            )
          : _vm._e(),
        _vm._m(0),
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-md-2 col-sm-12" }, [
            _c(
              "div",
              {
                staticClass: "scoped-flex-bysize",
                attrs: { id: "emailtemplates--type-select-sidebar" }
              },
              _vm._l(_vm.possibletemplateTypes, function(templateType, type) {
                return _c(
                  "div",
                  {
                    key: type,
                    staticClass:
                      "scoped-tabbable-item btn btn-block btn-default",
                    class: _vm.currentTemplateType == type ? "active" : "",
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.setTemplateType(type)
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm._f("translate")(templateType.title)) +
                        "\n                    "
                    )
                  ]
                )
              }),
              0
            )
          ]),
          _c(
            "div",
            {
              staticClass:
                "col-md-10 col-sm-12 ls-space margin top-5 bottom-5 scope-contains-ckeditor",
              attrs: { id: "emailtemplates--type-select-editorbody" }
            },
            [
              _c("div", { staticClass: "container-fluid" }, [
                _c("div", { staticClass: "row ls-space margin top-5" }, [
                  _c("div", { staticClass: "ls-flex-row col-12" }, [
                    _c("label", { attrs: { for: "currentSubject" } }, [
                      _vm._v(_vm._s(_vm.currentTemplateTypeData.subject || ""))
                    ])
                  ]),
                  !_vm.$store.state.permissions.update
                    ? _c("div", {
                        staticClass: "col-12",
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.stripScripts(_vm.currentSubject)
                          )
                        }
                      })
                    : _vm._e(),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.currentSubject,
                        expression: "currentSubject"
                      }
                    ],
                    staticClass: "form-control",
                    attrs: { name: "currentSubject", id: "currentSubject" },
                    domProps: { value: _vm.currentSubject },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.currentSubject = $event.target.value
                      }
                    }
                  })
                ]),
                _c(
                  "div",
                  {
                    staticClass: "row ls-space margin top-15 ckedit-nocollapse",
                    attrs: { id: "EmailTemplates--editor-container" }
                  },
                  [
                    _c("div", { staticClass: "ls-flex-row col-12" }, [
                      _c("div", { staticClass: "ls-flex-item text-left" }, [
                        _c("label", {}, [
                          _vm._v(_vm._s(_vm.currentTemplateTypeData.body))
                        ])
                      ]),
                      _vm.$store.state.permissions.update
                        ? _c(
                            "div",
                            { staticClass: "ls-flex-item text-right" },
                            [
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-default btn-xs",
                                  on: {
                                    click: function($event) {
                                      $event.preventDefault()
                                      _vm.sourceMode = !_vm.sourceMode
                                    }
                                  }
                                },
                                [
                                  _c("i", { staticClass: "fa fa-file-code-o" }),
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("translate")("Toggle source mode")
                                    )
                                  )
                                ]
                              )
                            ]
                          )
                        : _vm._e()
                    ]),
                    !_vm.$store.state.permissions.update
                      ? _c("div", {
                          staticClass: "col-12",
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.stripScripts(_vm.currentEditorContent)
                            )
                          }
                        })
                      : _vm._e(),
                    !_vm.sourceMode && _vm.$store.state.permissions.update
                      ? _c("lsckeditor", {
                          attrs: {
                            editor: _vm.currentEditorObject,
                            config: _vm.currentEditorOptions,
                            "extra-data": _vm.editorExtraOptions
                          },
                          on: { ready: _vm.onReadySetEditor },
                          model: {
                            value: _vm.currentEditorContent,
                            callback: function($$v) {
                              _vm.currentEditorContent = $$v
                            },
                            expression: "currentEditorContent"
                          }
                        })
                      : _vm._e(),
                    _vm.sourceMode && _vm.$store.state.permissions.update
                      ? _c("aceeditor", {
                          attrs: {
                            "apply-external-change": _vm.applyExternalChange,
                            thisId: "currentTemplateTypesSourceEditor",
                            showLangSelector: false
                          },
                          on: {
                            "external-change-applied": function($event) {
                              _vm.applyExternalChange = false
                            }
                          },
                          model: {
                            value: _vm.currentEditorContent,
                            callback: function($$v) {
                              _vm.currentEditorContent = $$v
                            },
                            expression: "currentEditorContent"
                          }
                        })
                      : _vm._e()
                  ],
                  1
                ),
                _c("div", { staticClass: "row ls-space margin top-15" }, [
                  _c("div", { staticClass: "ls-flex-row col-12" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-default",
                        attrs: {
                          id:
                            "EmailTemplates--actionbutton-validateCurrentContent"
                        },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.validateCurrentContent($event)
                          }
                        }
                      },
                      [_vm._v(" " + _vm._s("Validate Expressions") + " ")]
                    ),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-default",
                        attrs: {
                          id: "EmailTemplates--actionbutton-resetCurrentContent"
                        },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.resetCurrentContent($event)
                          }
                        }
                      },
                      [_vm._v(" " + _vm._s("Reset to default") + " ")]
                    ),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-default",
                        attrs: {
                          id: "EmailTemplates--actionbutton-addFileToCurrent"
                        },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.addFileToCurrent($event)
                          }
                        }
                      },
                      [
                        _vm._v(
                          " " + _vm._s("Add attachment to templates") + " "
                        )
                      ]
                    )
                  ])
                ]),
                _vm.hasAttachments
                  ? _c("div", { staticClass: "row ls-space margin top-15" }, [
                      _c(
                        "div",
                        { staticClass: "scoped-simple-carousel ls-flex-row" },
                        _vm._l(_vm.currentAttachments, function(file) {
                          return _c(
                            "div",
                            {
                              key: file.hash,
                              staticClass: "simple-carousel-item"
                            },
                            [
                              _c("i", {
                                staticClass:
                                  "fa fa-times text-danger simple-carousel-delete",
                                on: {
                                  click: function($event) {
                                    return _vm.deleteAttachment(file)
                                  }
                                }
                              }),
                              file.isImage != "false"
                                ? _c("img", {
                                    staticClass: "scoped-contain-image",
                                    attrs: {
                                      src: file.src,
                                      alt: file.shortName
                                    }
                                  })
                                : _c("i", {
                                    class: "fa " + file.iconClass + " fa-4x"
                                  })
                            ]
                          )
                        }),
                        0
                      )
                    ])
                  : _vm._e()
              ])
            ]
          )
        ])
      ],
      _vm.loading
        ? _c(
            "div",
            [
              _c("loader-widget", {
                attrs: { id: "emailtemplatesinternalloader" }
              })
            ],
            1
          )
        : _vm._e(),
      _c("modals-container")
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [_c("hr")])
  }
]
render._withStripped = true

export { render, staticRenderFns }